import { RootState } from '../../interfaces/rootState';

export const MyFiltersSelector = ({ userProfile }: RootState) => userProfile.userProfileDetails.savedFilters || {};
